module.exports = __webpack_public_path__ + "img/xmjl.5d5236d4.png";